import { Typography } from "@material-ui/core";
import React from "react";
import { ItemState } from "../../redux/state";
import { SelfDeclaration } from "../Sections/SelfDeclaration";
import { ConflictOfInterest } from "../Sections/ConflictOfInterest";
import { IndustryExpertise } from "../Sections/IndustryExpertise";
import { AssessmentExpertise } from "../Sections/AssessmentExpertise";
import { ProfessionalMemberships } from "../Sections/ProfessionalMemberships";
import { References } from "../Sections/References";
import { CommunicationJudgement } from "../Sections/CommunicationJudgement";
import { WorkHistory } from "../Sections/WorkHistory";
import { PersonalDetails } from "../Sections/PersonalDetails";
import { SupportingEvidenceExpertise } from "../Sections/SupportingEvidenceExpertise";
import { Subjects } from "../Sections/Subjects";
import { TeachingExpertise } from "../Sections/TeachingExpertise";
import { ExpertiseType } from "../../domain/SubjectModel";
import { Qualifications } from "../Sections/Qualification";
import { useRefSubjects } from "../../hooks/useRefSubjects";
import { ExpertsApplyModel } from "../../domain/ExpertsApplyFormModel";
import { SectionProps } from "../Sections/SectionProps";

export const ItemDetails: React.FC<{
  state: ItemState;
  sectionProps: SectionProps<ExpertsApplyModel>;
}> = ({ state, sectionProps }) => {
  const item = state.item!;
  const refSubjects = useRefSubjects(state.item!.subjects);

  return (
    <>
      <div>
        <form>
          <Typography variant="h6">Personal details</Typography>
          <PersonalDetails personalDetails={item.personalDetails} />

          <Typography variant="h6">Education details</Typography>
          <Qualifications
            sectionProps={sectionProps}
            qualifications={item.qualifications}
          />

          <Typography variant="h6">Work history</Typography>
          <WorkHistory roles={item.roles} />

          <Typography variant="h6">Professional memberships</Typography>
          <ProfessionalMemberships
            hasProfessionalMemberships={item.hasProfessionalMembership}
            professionalMemberships={item.professionalMemberships}
          />

          <Typography variant="h6">References</Typography>
          <References references={item.references} />

          <Typography variant="h6">Subjects</Typography>
          <Subjects subjects={item.subjects} />

          {item.subjects.some(
            (subject) => subject.expertiseType & ExpertiseType.Assessment
          ) && (
            <>
              <form data-test="details-assessment-experience-form">             
              <Typography variant="h6">Assessment experience</Typography>
              <AssessmentExpertise
                dialogTitle={`Set assessment experience approval status for ${item.personalDetails.fullName}`}
                assessmentExpertise={item.assessmentExpertise}
                subjects={item.subjects}
                refSubjects={refSubjects}
                />
              </form>
            </>
          )}

          {item.subjects.some(
            (subject) => subject.expertiseType & ExpertiseType.Industry
          ) && (
            <>
              <form data-test="details-industry-experience-form">             
              <Typography variant="h6">
                Industry, occupational or professional experience
              </Typography>
              <IndustryExpertise
                industryExpertise={item.industryExpertise}
                subjects={item.subjects}
                refSubjects={refSubjects}
                dialogTitle={`Set industry occupational experience approval status for ${item.personalDetails.fullName}`}
                />
              </form>
            </>
          )}

          {item.subjects.some(
            (subject) => subject.expertiseType & ExpertiseType.Teaching
          ) && (
            <>
              <form data-test="details-teaching-experience-form">
              <Typography variant="h6">
                Teaching, lecturing or training experience
              </Typography>
              <TeachingExpertise
                teachingExpertise={item.teachingExpertise}
                subjects={item.subjects}
                refSubjects={refSubjects}
                dialogTitle={`Set teaching, lecturing or training experience approval status for ${item.personalDetails.fullName}`}
                />
               </form>
            </>
          )}

          <Typography variant="h6">
            Communication and analytical judgement skills
          </Typography>
          <CommunicationJudgement
            communicationJudgement={item.communicationJudgement}
          />

          <Typography variant="h6">Further supporting evidence</Typography>
          <SupportingEvidenceExpertise
            supportingEvidenceExpertise={item.supportingEvidenceExpertise}
          />

          <Typography variant="h6">Conflict of interest</Typography>
          <ConflictOfInterest
            hasConflictOfInterest={item.hasConflictOfInterest}
            conflictOfInterests={item.conflictInterests}
          />

          <Typography variant="h6">Self declaration</Typography>
          <SelfDeclaration selfDeclaration={item.selfDeclaration} />
        </form>
      </div>
    </>
  );
};
